var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiBowlOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 12v3c0 3.9 3.1 7 7 7h6c3.9 0 7-3.1 7-7v-3zm2 2h16v1c0 2.8-2.2 5-5 5H9c-2.8 0-5-2.2-5-5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiBowlOutline);
export default __webpack_public_path__ + "static/media/mdi--bowl-outline.c0a03b66bed4feb35383b1e65a1a4e33.svg";
export { ForwardRef as ReactComponent };